<template>
  <div>
    <div class="numpad-overlay" @click="closeNumpad"></div>
    <div class="custom-numpad" id="numpad">
      <div class="numpad-header">
        <div
          class="numpad-header-left"
          id="numpad-title"
          data-langName="amount"
        >
          Amount
        </div>
        <div class="numpad-header-right" id="numpad-title-value">
          {{ startingBetValue }}
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="numpad-predefined">
        <div class="predefined-nums">
          <button
            class="default btn-min"
            data-numpad="predefined"
            :data-predefined="getGameConfig.Bingo_MinBet"
            @click="setAmount(minBetValue)"
          >
            min
          </button>
          <button
            class="default num-pre"
            data-numpad="predefined"
            :data-predefined="getGameConfig.CustomAmount1"
            @click="setAmount(getGameConfig.CustomAmount1)"
          >
            &nbsp;{{ getGameConfig.CustomAmount1 }}
          </button>
          <button
            class="default num-pre"
            data-numpad="predefined"
            :data-predefined="getGameConfig.CustomAmount2"
            @click="setAmount(getGameConfig.CustomAmount2)"
          >
            &nbsp;{{ getGameConfig.CustomAmount2 }}
          </button>
          <button
            class="default num-pre"
            data-numpad="predefined"
            :data-predefined="getGameConfig.CustomAmount3"
            @click="setAmount(getGameConfig.CustomAmount3)"
          >
            &nbsp;{{ getGameConfig.CustomAmount3 }}
          </button>
          <button
            class="default btn-max"
            data-numpad="predefined"
            :data-predefined="maxBetValue"
            @click="setAmount(maxBetValue)"
          >
            max
          </button>
        </div>
      </div>
      <div class="numpad-nums">
        <button
          class="default num-value"
          data-numpad="value"
          data-num="1"
          @click="setTempAmount('1')"
        >
          1
        </button>
        <button
          class="default num-value"
          data-numpad="value"
          data-num="2"
          @click="setTempAmount('2')"
        >
          2
        </button>
        <button
          class="default num-value"
          data-numpad="value"
          data-num="3"
          @click="setTempAmount('3')"
        >
          3
        </button>
        <button
          class="default num-value"
          data-numpad="value"
          data-num="4"
          @click="setTempAmount('4')"
        >
          4
        </button>
        <button
          class="default num-value"
          data-numpad="value"
          data-num="5"
          @click="setTempAmount('5')"
        >
          5
        </button>
        <button
          class="default num-value"
          data-numpad="value"
          data-num="6"
          @click="setTempAmount('6')"
        >
          6
        </button>
        <button
          class="default num-value"
          data-numpad="value"
          data-num="7"
          @click="setTempAmount('7')"
        >
          7
        </button>
        <button
          class="default num-value"
          data-numpad="value"
          data-num="8"
          @click="setTempAmount('8')"
        >
          8
        </button>
        <button
          class="default num-value"
          data-numpad="value"
          data-num="9"
          @click="setTempAmount('9')"
        >
          9
        </button>
        <button
          class="default num-value"
          data-numpad="value"
          data-num="."
          @click="setTempAmount('.')"
        >
          .
        </button>
        <button
          class="default num-value"
          data-numpad="value"
          data-num="0"
          @click="setTempAmount('0')"
        >
          0
        </button>
        <button
          class="default delete num-value"
          data-numpad="delete"
          data-num="delete"
          @click="removeTempAmount()"
        >
          &nbsp;
        </button>
        <div class="clearfix"></div>
      </div>

      <div class="numpad-action">
        <button class="default num-ok" id="numpad-ok" @click="setBetAmount">
          OK
        </button>
        <button
          v-if="this.$router.history.current.name !== 'Bingo49'"
          class="btn-pay num-pay"
          id="numpad-buy"
          data-langName="buy_ticket"
          @click="buyTicket"
        >
          BUY TICKET
        </button>
      </div>
      <input type="hidden" id="num-value" />
    </div>
  </div>
</template>

<script>
import $eventBus from "../../../eventBus";
import { mapGetters } from "vuex";
import { translate } from "../../../assets/common/lang";

export default {
  data() {
    return {
      minBetValue: 0.5,
      startingBetValue: 1,
      maxBetValue: 0,
      arrValue: [],
      total: 0,
    };
  },
  methods: {
    translate(word) {
      return translate(word);
    },
    closeNumpad() {
      $eventBus.$emit("closeNumpad");
    },
    setTempAmount(val) {
      //Allow only two decimal places
      if (this.startingBetValue % 1 != 0 && val != "delete") {
        if (this.startingBetValue.toString().split(".")[1].length == 2) {
          return false;
        }
      }
      // Check if decimal place exist in array
      if (val === ".") {
        if (this.startingBetValue == 0) {
          this.arrValue.push(val);
          return false;
        }
        if (this.arrValue.includes(val)) {
          return false;
        }
      }

      console.log("->>>>>val>>>->", val);
      console.log("->>>>>this.startingBetValue>>>->", this.startingBetValue);

      if (this.startingBetValue == 0 && val == 0) {
        return false;
      }
      this.arrValue.push(val);
      this.startingBetValue =
        Number(this.arrValue.join("")) > this.maxBetValue
          ? this.maxBetValue
          : Number(this.arrValue.join(""));

      if (this.startingBetValue == ".") {
        this.startingBetValue = 0;
      }
    },
    removeTempAmount() {
      this.arrValue = this.arrValue.slice(0, -1);
      this.startingBetValue =
        this.arrValue.length == 0 ? 0 : this.arrValue.join("");
    },
    updateMinBetValue(betValue) {
      this.minBetValue = betValue;
    },
    updateMaxBetValue() {
      if (
        typeof getMainConfig === "object" &&
        Object.keys(this.getMainConfig).length
      ) {
        if (
          Number(this.getGameConfig.Bingo_MaxBet) >
          Number(this.getMainConfig.TerminalCredit)
        ) {
          this.maxBetValue = Number(this.getMainConfig.TerminalCredit);
        } else {
          this.maxBetValue = Number(this.getGameConfig.Bingo_MaxBet);
        }
      }
    },
    updateStartingBetValue() {
      this.startingBetValue = this.getGameConfig.Bingo_MinBet;
    },
    setAmount(amount) {
      this.startingBetValue = amount;
    },
    setBetAmount() {
      if (this.startingBetValue == ".") {
        this.startingBetValue = 0;
      }
      $eventBus.$emit("setBetFromNumpad", this.startingBetValue);
      this.closeNumpad();
    },
    buyTicket() {
      $eventBus.$emit("buyTicketFromNumpad", this.startingBetValue);
      $eventBus.$emit("setTicketAmount", this.startingBetValue);
      this.closeNumpad();
    },
  },
  computed: {
    ...mapGetters(["getGameConfig", "getMainConfig"]),
  },
  mounted() {
    this.updateMaxBetValue();
    if (!this.getGameConfig) {
      this.$bvToast.toast("NO MAIN CONFIG", {
        title: translate("notification"),
        variant: "danger",
        autoHideDelay: 3000,
      });
    } else {
      // this.$bvToast.toast("NICE" + this.getGameConfig.Bingo_MaxBet, {
      //   title: translate("notification"),
      //   variant: "danger",
      //   autoHideDelay: 3000,
      // });

      this.maxBetValue = this.getGameConfig.Bingo_MaxBet;
    }

    $eventBus.$on("minBetValue", (minBetValue) => {
      this.updateMinBetValue(minBetValue);
      this.updateMaxBetValue();
    });
    $eventBus.$on("clearAllBets", () => {
      this.updateStartingBetValue();
      this.updateMaxBetValue();
    });
  },
  watch: {
    getGameConfig() {
      if (!this.getGameConfig) {
        this.$bvToast.toast("There was an error communicating with API", {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 3000,
          toaster: "b-toaster-top-center",
        });
        return;
      }
      this.updateStartingBetValue();
      this.updateMaxBetValue();
    },
  },
  beforeDestroy() {
    //$eventBus.$off(`setBetFromNumpad`);
    //$eventBus.$off(`buyTicketFromNumpad`);
    this.arrValue = [];
    this.updateStartingBetValue();
    this.updateMaxBetValue();
    //$eventBus.$off(`closeNumpad`);
  },
};
</script>